(() => {
class SleepCityHeader {
  constructor(root) {
    this.root = root;
    this.section = root.closest('.shopify-section');
    this.drawer = root.querySelector('[data-sc-drawer]');
    this.openButtons = root.querySelectorAll('[data-sc-drawer-open]');
    this.closeButton = root.querySelector('[data-sc-drawer-close]');
    this.search = root.querySelector('[data-sc-search]');
    this.searchToggle = root.querySelector('[data-sc-search-toggle]');
    this.navDetails = root.querySelectorAll('[data-sc-nav-details]');
    this.stickyBehavior = root.dataset.stickyBehavior;
    this.lastScrollPosition = window.scrollY;
    this.opener = null;

    this.bindDrawer();
    this.bindDesktopSearch();
    this.bindSearchResetButtons();
    this.bindNavigation();
    this.bindStickyHeader();
  }

  bindDrawer() {
    if (!this.drawer) return;

    this.openButtons.forEach((button) => {
      button.addEventListener('click', () => this.openDrawer(button));
    });

    this.closeButton?.addEventListener('click', () => this.drawer.close());

    this.drawer.addEventListener('click', (event) => {
      if (event.target === this.drawer) this.drawer.close();
    });

    this.drawer.addEventListener('close', () => {
      document.documentElement.classList.remove('sc-header-drawer-open');
      this.openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      this.opener?.focus();
      this.opener = null;
    });
  }

  openDrawer(button) {
    if (!this.drawer || this.drawer.open) return;

    this.opener = button;
    button.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('sc-header-drawer-open');
    this.drawer.showModal();

    if (button.hasAttribute('data-sc-focus-search')) {
      window.requestAnimationFrame(() => {
        this.drawer.querySelector('input[type="search"]')?.focus();
      });
    } else {
      window.requestAnimationFrame(() => this.closeButton?.focus());
    }
  }

  bindDesktopSearch() {
    if (!this.search || !this.searchToggle) return;

    this.searchToggle.addEventListener('click', () => {
      const isOpen = this.search.classList.toggle('is-open');
      this.searchToggle.setAttribute('aria-expanded', String(isOpen));

      if (isOpen) {
        this.search.querySelector('input[type="search"]')?.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!this.search.contains(event.target)) this.closeDesktopSearch();
    });

    this.search.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeDesktopSearch();
        this.searchToggle.focus();
      }
    });
  }

  closeDesktopSearch() {
    if (!this.search || !this.searchToggle) return;
    this.search.classList.remove('is-open');
    this.searchToggle.setAttribute('aria-expanded', 'false');
  }

  bindSearchResetButtons() {
    this.root.querySelectorAll('.sc-header__search-form').forEach((form) => {
      const input = form.querySelector('input[type="search"]');
      const resetButton = form.querySelector('button[type="reset"]');
      if (!input || !resetButton) return;

      const updateResetButton = () => {
        resetButton.classList.toggle('hidden', input.value.length === 0);
      };

      input.addEventListener('input', updateResetButton);
      form.addEventListener('reset', () => window.requestAnimationFrame(updateResetButton));
      updateResetButton();
    });
  }

  bindNavigation() {
    document.addEventListener('click', (event) => {
      this.navDetails.forEach((details) => {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    });

    this.navDetails.forEach((details) => {
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          details.removeAttribute('open');
          details.querySelector('summary')?.focus();
        }
      });
    });
  }

  bindStickyHeader() {
    if (!this.section || this.stickyBehavior === 'none') return;

    this.section.classList.add('sc-header-section--sticky');
    if (this.stickyBehavior === 'always') return;

    window.addEventListener(
      'scroll',
      () => {
        const currentScrollPosition = window.scrollY;
        const isPastHeader = currentScrollPosition > this.root.offsetHeight;
        const isScrollingDown = currentScrollPosition > this.lastScrollPosition;

        this.section.classList.toggle(
          'sc-header-section--hidden',
          isPastHeader && isScrollingDown && !this.drawer?.open
        );

        this.lastScrollPosition = currentScrollPosition;
      },
      { passive: true }
    );
  }
}

const initializeHeaders = (scope = document) => {
  scope.querySelectorAll('[data-sc-header]').forEach((header) => {
    if (header.dataset.scHeaderReady === 'true') return;
    header.dataset.scHeaderReady = 'true';
    new SleepCityHeader(header);
  });
};

initializeHeaders();
document.addEventListener('shopify:section:load', (event) => initializeHeaders(event.target));
})();
